export interface AppConfig {
  apiUrl: string;
  envName: string;
  oktaIssuer: string;
  oktaClientId: string;
  authDisabled: boolean;
}

let _config: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch("/config.json");
  if (!res.ok) {
    throw new Error(`Failed to load /config.json: ${res.status}`);
  }
  _config = (await res.json()) as AppConfig;
  return _config;
}

export function getConfig(): AppConfig {
  if (!_config) {
    throw new Error("Config not loaded. Call loadConfig() before getConfig().");
  }
  return _config;
}
